/* jshint esversion: 6 */
import React from 'react';
import DlvrRouter from 'app/components/Routers/DlvrRouter.jsx';
import ClientRouter from 'app/components/Routers/ClientRouter.jsx';
import BootstrapProvider from 'app/redux/Providers/BootstrapProvider.jsx';
import { compose } from 'redux';

class AppSwitcher extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isClient: null
        };
    }

    static getDerivedStateFromProps(props, state) {
        let bootstrap = props.bootstrap;

        if (bootstrap.configLoaded === true && state.isClient === null) {
            return {
                isClient: bootstrap.isClient
            };
        }

        return null;

    }

	render() {
		let AppRouter = DlvrRouter;

		// don't render any routes until we know if this is a client or agent
		if (this.state.isClient !== null) {
			if (this.state.isClient === 1) {
				AppRouter = ClientRouter;
			}
		} else {
			return null;
		}

		return (
			<AppRouter/>
		);
	}
}

const enhance = compose(
    BootstrapProvider
);

AppSwitcher.displayName = "AppSwitcher";

export default enhance(AppSwitcher);
